<template>
    <div>
        <dx-grid
            :url="url"
            :columns="columns"
            :actions="actions"
            :title="title"
            :onRowClicked="onRowClicked"
            navigationPath="onRowClicked"
            navigationField="onRowClicked"
            :beforeSetupGrid="beforeSetupGrid"
            :selectionEnabled="true"
            ref="grid"
        ></dx-grid>

        <v-dialog persistent v-model="addNewContactDialog" max-width="400">
            <v-card class="pa-3">
                <v-card-title class="headline pl-0 pt-0"
                    >New Contact</v-card-title
                >
                <v-text-field
                    class="mx-2 mb-2"
                    v-model="newContact.phoneNumber"
                    label="Phone Number"
                    ref="newPhoneNumber"
                    :rules="[rules.phoneNumber, rules.required]"
                ></v-text-field>
                <v-layout class="pa-0">
                    <v-text-field
                        class="mx-2 mb-2"
                        v-model="newContact.name"
                        label="Name"
                        ref="newName"
                        :rules="[rules.required]"
                    ></v-text-field>
                    <!-- <v-btn
                        class="mb-0 pt-1"
                        :disabled="!newContact.name"
                        @click="playText(newContact.name)"
                        flat
                        icon
                        color="info"
                    >
                        <v-icon>mdi-play-circle</v-icon>
                    </v-btn> -->
                </v-layout>
                <v-text-field
                    class="mx-2 mb-2"
                    v-model="newContact.nameH"
                    label="Hebrew Name"
                    ref="newNameH"
                    :rules="[rules.required]"
                ></v-text-field>
                <v-text-field
                    class="mx-2 mb-1"
                    v-model="newContact.note"
                    label="Note"
                    ref="note"
                ></v-text-field>
                <v-select
                    class="mx-2 mt-0"
                    v-model="newContact.branch"
                    label="Branch"
                    multiple
                    :items="branchList"
                ></v-select>
                <v-card-actions class="mx-0 px-2 pb-2 mt-2">
                    <v-spacer></v-spacer>
                    <v-btn
                        color="default"
                        dark
                        @click="addNewContactDialog = false"
                        >Cancel</v-btn
                    >
                    <v-btn
                        :loading="processing"
                        color="success"
                        @click="saveNewContact()"
                    >
                        Save
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog persistent v-model="updateContactDialog" max-width="400">
            <v-card class="pa-3">
                <v-card-title class="headline pl-2 pt-2"
                    >Update Contact - {{ rowClicked.nameH }}</v-card-title
                >

                <v-layout row>
                    <v-layout column xs6 class="pr-2" style="min-width: 40%">
                        <v-text-field
                            class="mx-2"
                            v-model="rowClicked.phoneNumber"
                            label="Phone Number"
                            ref="phoneNumber"
                            :rules="[rules.phoneNumber, rules.required]"
                        ></v-text-field>
                        <v-layout class="pa-0">
                            <v-text-field
                                class="mx-2 pt-2"
                                v-model="rowClicked.name"
                                label="Name"
                                ref="name"
                                :rules="[rules.required]"
                            ></v-text-field>
                            <!-- <v-btn
                                class="mb-0 pt-1"
                                :disabled="!rowClicked.name"
                                @click="playText(rowClicked.name)"
                                flat
                                icon
                                color="info"
                            >
                                <v-icon>mdi-play-circle</v-icon>
                            </v-btn> -->
                        </v-layout>
                        <v-layout class="pa-0">
                            <v-text-field
                                class="mx-2 pt-2"
                                v-model="rowClicked.nameH"
                                label="Hebrew Name"
                                ref="nameH"
                                :rules="[rules.required]"
                            ></v-text-field>
                        </v-layout>
                        <v-text-field
                            class="mx-2 pt-2"
                            v-model="rowClicked.note"
                            label="Note"
                            ref="note"
                        ></v-text-field>
                        <v-select
                            class="mx-2"
                            v-model="rowClicked.branch"
                            label="Branch"
                            ref="branch"
                            multiple
                            :items="branchList"
                        ></v-select>
                    </v-layout>
                </v-layout>
                <v-card-actions class="mx-0 px-2 pb-2 mt-2">
                    <v-spacer></v-spacer>
                    <v-btn
                        color="default"
                        dark
                        @click="updateContactDialog = false"
                        >Cancel</v-btn
                    >
                    <v-btn
                        color="warning"
                        dark
                        :disabled="deleting"
                        @click="deleteDialog = true"
                        >Delete</v-btn
                    >
                    <v-btn
                        :loading="processing"
                        color="success"
                        @click="save()"
                    >
                        Save
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="deleteDialog" max-width="400">
            <v-card class="pa-2">
                <v-card-title class="pl-2 pt-2 headline text-danger"
                    >Are You Sure?</v-card-title
                >
                <v-card-text class="pt-0 pl-2"
                    >This will delete:
                    <div class="font-weight-medium">
                        {{
                            rowClicked.nameH
                                ? rowClicked.nameH
                                : rowClicked.name
                        }}
                    </div></v-card-text
                >
                <v-card-actions class="mr-2">
                    <v-spacer></v-spacer>
                    <v-btn color="default" dark @click="deleteDialog = false"
                        >Cancel</v-btn
                    >
                    <v-btn
                        color="success"
                        :loading="deleting"
                        @click="deleteContact"
                        >Delete</v-btn
                    >
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="importContactsDialog" max-width="1000">
            <v-card class="pa-2">
                <v-card-title class="pl-2 pt-2 headline"
                    >Import Contacts</v-card-title
                >
                <v-layout row class="mb-2 mx-2">
                    <a @click.stop="downloadSampleFile()" class=""
                        >Sample File</a
                    ></v-layout
                >
                <v-layout row class="mx-2 mb-2">
                    <v-btn
                        small
                        style="width: 150px; height: 34px;"
                        color="blue-grey"
                        class="white--text mt-0"
                        :loading="uploading"
                        @click="pickFile()"
                    >
                        <v-icon left dark>mdi-cloud-upload</v-icon>
                        Upload Numbers
                    </v-btn>
                    <input
                        type="file"
                        style="display: none"
                        ref="files"
                        accept=".csv, .xlsx, .xls"
                        @input="onFilePicked($event)"
                        onclick="this.value = null"
                    />
                </v-layout>

                <div v-if="uploading">
                    <v-container fluid grid-list-md>
                        <v-layout
                            align-center
                            justify-center
                            row
                            fill-height
                            class="mt-5 text-xs-center"
                        >
                            <v-progress-circular
                                :size="100"
                                :width="3"
                                color="rgba(0,0,0,.38)"
                                indeterminate
                            ></v-progress-circular>
                        </v-layout>
                    </v-container>
                </div>

                <vue-good-table
                    v-if="contactsToImport.length"
                    class="number-list mx-2"
                    :columns="importColumns"
                    :rows="contactsToImport"
                    :search-options="{
                        enabled: false,
                    }"
                >
                    <template slot="table-row" slot-scope="props">
                        <v-layout column class="ma-0 pa-0">
                            <span>
                                {{ props.formattedRow[props.column.field] }}
                            </span>
                            <span
                                class="text-danger pa-0 ma-0"
                                style="font-size: 11px;"
                                v-if="getError(props.row, props.column.field)"
                            >
                                {{ getError(props.row, props.column.field) }}
                            </span>
                        </v-layout>
                    </template>
                </vue-good-table>

                <v-card-actions class="mr-2 mt-3">
                    <v-spacer></v-spacer>
                    <v-btn
                        color="default"
                        dark
                        @click="importContactsDialog = false"
                        >Cancel</v-btn
                    >
                    <v-btn
                        color="success"
                        :loading="processing"
                        @click="importContacts"
                        >import</v-btn
                    >
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog persistent v-model="deleteContactsDialog" max-width="400">
            <v-card class="pa-3">
                <v-card-title class="headline pl-0 pt-0"
                    >Delete Contacts</v-card-title
                >
                <div class="font-weight-regular">
                    The {{ selected.length }} selected contacts will be deleted
                </div>
                <v-card-actions class="mr-0 mt-3">
                    <v-spacer></v-spacer>
                    <v-btn
                        color="default"
                        dark
                        @click="deleteContactsDialog = false"
                        >Cancel</v-btn
                    >
                    <v-btn
                        :loading="processing"
                        color="success"
                        @click="deleteContacts"
                    >
                        Delete
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>
<script>
import moment from "moment";
import AWS from "aws-sdk";

export default {
    data: () => ({
        title: "Broadcast Contacts",

        actions: [],

        updateContactDialog: false,
        importContactsDialog: false,

        rowClicked: {
            id: "",
            name: "",
            nameH: "",
            phoneNumber: "",
            type: "",
            branch: [],
            note: "",
        },

        newContact: {
            id: "",
            name: "",
            nameH: "",
            phoneNumber: "",
            type: "CONTACTS",
            branch: [],
            note: "",
        },

        processing: false,
        uploading: false,
        deleteDialog: false,
        deleteContactsDialog: false,
        deleting: false,
        selected: [],
        files: [],
        contactsToImport: [],
        url: "",
        awsPolly: "",
        branchList: [],

        addNewContactDialog: false,

        rules: {
            required: (value) => !!value || "Required.",
            pinNumber: (v) => {
                return (
                    !v ||
                    ([5].includes(v.replace(/-/g, "").length) &&
                        /^\d+$/.test(v.replace(/-/g, ""))) ||
                    "Invalid Pin Number, Must be 5 digits"
                );
            },
            phoneNumber: (v) => {
                return (
                    !v ||
                    ([10, 11].includes(v.replace(/-/g, "").length) &&
                        /^\d+$/.test(v.replace(/-/g, ""))) ||
                    "Invalid Phone Number"
                );
            },
        },

        columns: [
            {
                label: "ID",
                field: "id",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Hebrew Name",
                field: "nameH",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Name",
                field: "name",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Branch",
                field: "branch",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Phone Number",
                field: "phoneNumber",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Created By",
                field: "createdBy",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Entered On",
                field: "enteredOn",
                visible: true,
                type: "date",
                format: "MM/dd/yyyy hh:mm:ss a",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Note",
                field: "note",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
        ],

        importColumns: [
            {
                sortable: false,
                label: "Name",
                field: "name",
            },
            {
                sortable: false,
                label: "Hebrew Name",
                field: "nameH",
            },
            {
                sortable: false,
                label: "Branch",
                field: "branch",
            },
            {
                sortable: false,
                label: "Phone Number",
                field: "phoneNumber",
            },
            {
                sortable: false,
                label: "Note",
                field: "note",
            },
        ],
    }),
    async mounted() {
        const settings = await this.getAwsSettings();

        this.awsPolly = new AWS.Polly({
            accessKeyId: settings.accessKey,
            secretAccessKey: settings.secretKey,
            region: "us-east-1",
        });
    },
    beforeDestroy() {},
    async created() {
        this.loadBranches();
    },
    methods: {
        async getAwsSettings() {
            const response = await this.$http.get(
                "api/adminPortal/GetAwsPollyCredentials",
            );

            return response;
        },
        async beforeSetupGrid() {
            if (this.getBranch()) {
                this.userBranch = this.getBranch();
            }

            this.actions.push({
                text: "Delete Contacts",
                action: this.openDeleteContactsDialog,
                showOnSelection: true,
            });

            this.actions.push({
                text: "Add Contact",
                action: this.addContact,
            });

            this.actions.push({
                text: "import Contacts",
                action: this.openImportContactsDialog,
            });

            this.url =
                "broadcastContact?branch=" +
                (this.userBranch ? this.userBranch : "");
        },
        async loadBranches() {
            const branches = await this.$http.get(
                "api/students/getBranchList?grades=",
            );

            this.branchList = branches.filter(Boolean).sort();
            this.branchList.push("BUS");
        },
        getBranch() {
            return this.$store.state.authentication.branch &&
                !this.$store.state.authentication.branch.includes("null")
                ? this.$store.state.authentication.branch
                : "";
        },
        openImportContactsDialog() {
            this.importContactsDialog = true;
        },
        getError(row, field) {
            const errorField = field + "Error";

            return row[errorField];
        },
        getValidNumbers() {
            if (!this.contactsToImport.length) return;

            //return this.contactsToImport;

            return this.contactsToImport.filter((contact) => {
                console.log(contact);

                return !Object.keys(contact).some((key) =>
                    this.getError(contact, key),
                );
            });
        },
        async importContacts() {
            if (!this.getValidNumbers().length) {
                return this.$notify({
                    text: "No valid numbers to import",
                    group: "notification",
                    type: "error",
                });
            }

            try {
                this.processing = true;

                await this.$http.post(
                    "api/broadcastContact/saveInBulk",
                    this.getValidNumbers(),
                );

                this.processing = false;
                this.importContactsDialog = false;
                this.contactsToImport = [];
                this.files = [];

                this.$notify({
                    text: "Numbers Imported",
                    group: "notification",
                    type: "success",
                });

                this.$refs.grid.reloadGrid();
            } catch (e) {
                this.processing = false;
            }
        },
        async saveNewContact() {
            if (
                !this.$refs.newName.validate(true) ||
                !this.$refs.newNameH.validate(true) ||
                !this.$refs.newPhoneNumber.validate(true)
            )
                return;

            if (!this.newContact.branch.length) {
                return this.$notify({
                    text: "Please select branch",
                    group: "notification",
                    type: "error",
                });
            }

            try {
                this.processing = true;

                await this.$http.post("api/broadcastContact/save", {
                    phoneNumber: this.newContact.phoneNumber
                        ? this.newContact.phoneNumber.length == 11
                            ? this.newContact.phoneNumber
                            : "1" + this.newContact.phoneNumber
                        : "",
                    name: this.newContact.name,
                    nameH: this.newContact.nameH,
                    note: this.newContact.note,
                    branch: this.newContact.branch.join(","),
                    CreatedBy: this.$store.state.authentication.user,
                });

                this.processing = false;
                this.addNewContactDialog = false;

                this.newContact.id = "";
                this.newContact.phoneNumber = "";
                this.newContact.branch = [];
                this.newContact.name = "";
                this.newContact.nameH = "";
                this.newContact.note = "";
                this.newContact.type = "CONTACTS";

                this.$refs.grid.reloadGrid();
            } catch (e) {
                this.processing = false;
            }
        },
        async onRowClicked(row) {
            this.rowClicked = JSON.parse(JSON.stringify(row));
            this.rowClicked.branch = this.rowClicked.branch.split(",");

            this.updateContactDialog = true;
        },
        addContact() {
            this.newContact.type = "CONTACTS";

            this.addNewContactDialog = true;
        },
        openDeleteContactsDialog() {
            this.selected = this.$refs.grid.getSelectedRowsData();

            this.deleteContactsDialog = true;
        },
        async deleteContacts() {
            try {
                const ids = this.selected.map((s) => s.id);

                this.processing = true;

                await this.$http.post("api/broadcastContact/delete", ids);

                this.processing = false;
                this.deleteContactsDialog = false;

                this.$notify({
                    group: "notification",
                    text: ids.length + " Contacts Deleted",
                    type: "success",
                });

                this.$refs.grid.reloadGrid();
            } catch (e) {
                this.processing = false;
            }
        },
        playText(text) {
            let params = {
                OutputFormat: "mp3",
                Text: text,
                TextType: "text",
                VoiceId: "Matthew",
            };

            this.awsPolly.synthesizeSpeech(params, (err, data) => {
                const uInt8Array = new Uint8Array(data.AudioStream);
                const arrayBuffer = uInt8Array.buffer;
                const blob = new Blob([arrayBuffer]);
                const url = URL.createObjectURL(blob);
                console.log(url);
                var audio = new Audio(url);
                audio.play();
            });
        },
        downloadSampleFile() {
            window.location =
                "https://utaw.blob.core.windows.net/files/BroadcastContactsSample.xlsx";
        },
        pickFile() {
            this.$refs.files.click();
        },
        async onFilePicked(e) {
            this.uploading = true;

            const files = e.target.files;

            if (!files) return;

            try {
                var formData = new FormData();

                this.files = files;

                formData.append("upload_file", this.files[0]);

                const response = await this.$http.post(
                    "api/broadcastContact/Import?user=" +
                        this.$store.state.authentication.user,
                    formData,
                    {
                        headers: {
                            "Content-Type": "multipart/form-data",
                        },
                    },
                );

                this.contactsToImport = response.map((contact) => {
                    contact.nameError =
                        !contact.name && !contact.nameH ? "Name Required" : "";
                    contact.nameHError =
                        !contact.name && !contact.nameH
                            ? "Hebrew Name Required"
                            : "";
                    contact.branchError = !contact.branch
                        ? "Branch Required"
                        : "";
                    contact.phoneNumberError = this.isValidNumber(
                        contact.phoneNumber,
                    )
                        ? ""
                        : "Invalid Phone Number";
                    contact.phoneNumber =
                        this.isValidNumber(contact.phoneNumber) &&
                        contact.phoneNumber.length == 10
                            ? "1" + contact.phoneNumber
                            : contact.phoneNumber;

                    return contact;
                });

                console.log(this.contactsToImport);

                this.uploading = false;
            } catch (e) {
                this.uploading = false;
            }
        },
        isValidNumber(number) {
            if (!number) return;

            const value = number.replaceAll("-", "");

            const isOnlyNumbers = /^\d+$/.test(value.replace(/-/g, ""));

            return isOnlyNumbers && [10, 11].includes(value.length);
        },
        validate() {
            const validations = [];

            validations.push(this.$refs.name.validate(true));
            validations.push(this.$refs.nameH.validate(true));
            validations.push(this.$refs.phoneNumber.validate(true));

            return validations.every(Boolean);
        },
        async save() {
            if (!this.validate()) return;

            if (!this.rowClicked.branch.length) {
                return this.$notify({
                    text: "Please select branch",
                    group: "notification",
                    type: "error",
                });
            }

            try {
                this.processing = true;

                const data = JSON.parse(JSON.stringify(this.rowClicked));

                data.phoneNumber = data.phoneNumber
                    ? data.phoneNumber.replaceAll("-", "")
                    : data.phoneNumber;
                data.phoneNumber = data.phoneNumber
                    ? data.phoneNumber.length == 11
                        ? data.phoneNumber
                        : "1" + data.phoneNumber
                    : "";

                data.branch = data.branch.join(",");

                await this.$http.post("api/broadcastContact/save", data);

                this.updateContactDialog = false;
                this.processing = false;

                this.$refs.grid.reloadGrid();
            } catch (e) {
                this.processing = false;
            }
        },
        async deleteContact() {
            this.deleting = true;

            try {
                await this.$http.post("api/broadcastContact/delete", [
                    this.rowClicked.id,
                ]);

                this.deleteDialog = false;
                this.updateContactDialog = false;
                this.deleting = false;

                this.$refs.grid.reloadGrid();
            } catch (e) {
            } finally {
                this.deleting = false;
            }
        },
    },
};
</script>
<style>
.gray-fg {
    color: #999;
}
</style>
